import TalaeraBackground from "components/TalaeraBackground";
import Button from "components/ui/Button";
import "./UpdateInProgress.css";

type Props = {
  pingServer: () => void;
};

const UpdateInProgress = ({ pingServer }: Props) => {
  return (
    <TalaeraBackground>
      <div className="update-in-progress">
        The Talaera system is currently being upgraded. Please&nbsp;
        <Button variant="plain" onClick={pingServer}>
          check back
        </Button>{" "}
        in a few minutes.
      </div>
    </TalaeraBackground>
  );
};

export default UpdateInProgress;
